<template>
<div>
             <ul class="cb-slideshow">
              <li><span>Image 01</span></li>
             </ul>      
     <div class="container-fluid pl-3">
         <div class="row">
          <div class="col-md-6 p-2 text-white CusAdvisery">
           <strong>Customer Advisery : </strong>WtipsV3 is proprietery software of DCS cloud solutions, User sign-in will be resposible for the usage of the system under client name. 
                   Any illegal activity will be taken as breach of conduct and will be taken legal action upto maximum penalty under COMPUTER CRIME ACT, No. 24 OF 2007(Sri Lanka)
          </div>
          <div class="col-md-6 p-2 text-white text-md-right">
             <div class="icon"><i class="fa fa-info-circle"><a class="external CusAdvisery_help" href="#">&nbsp;Help and Support</a></i></div>
          </div>
         </div>      
     </div>
     <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-md-6 p-2 text-center">
                <h3 class="heading_comp_name">DCSCloud</h3>
            </div>
        </div>    
    </div>             
    <div class="container-fluid pl-3 login-page">
        <div class="row justify-content-end">
            <div class="col-md-4 p-2">
             <div class="form-inner">
              <div class="smallbar bg-danger"></div>
               <div class="logo text-center"><img width="44" height="44" src="static/images/logo.png"><span class="text-primary">WTIPS</span><span class="align-top text-dark"><strong>V3</strong></span></div>
               <p></p>
               <form class="text-left form-validate">
                 <div class="form-group-material">
                   <input id="login-username" type="text" name="loginUsername" required data-msg="Please enter your username" class="input-material" v-model="username" @focus="selected = 1" @blur="selected = 0"> 
                   <label for="login-username" class="label-material" :class="{active : selected == 1 ||username !== ''}">Username</label>
                 </div>
                 <div class="form-group-material">
                   <input id="login-password" type="password" name="loginPassword" required data-msg="Please enter your password" class="input-material" v-model="password" @focus="selected = 2" @blur="selected = 0">
                   <label for="login-password" class="label-material" :class="{active : selected == 2 ||password !== ''}">Password</label>
                </div>
                 <div class="form-group text-center text-white"><a id="login" class="btn btn-primary" v-on:click="login">Login</a>
                   <!-- This should be submit button but I replaced it with <a> for demo purposes-->
                 </div>
               </form>
               <a href="#" class="forgot-pass text-center">Forgot Password?</a>
              </div>               
            </div>    
        </div>    
    </div>
     <footer class="footer">        
          <div class="container">
              <div class="row">
                <div class="col">   
                   <p class="text-white">&copy; 2018 - <a class="text-white" href="http://www.dcscloudsolutions.com" >DCSCloud</a> <a href="http://www.dcscloudsolutions.com" class="external"> an Enterprise resource planner.</a></p>
                </div>
                <div class="col text-right">
                   <div class="icon lead">
                       <a class="text-white" href="#"><i class="p-2 fa fa-facebook-square"></i></a>
                       <a class="text-white" href="#"><i class="p-2 fa fa-twitter-square"></i></a>
                       <a class="text-white" href="#"><i class="p-2 fa fa-linkedin-square"></i></a>
                       <a class="text-white" href="#"><i class="p-2 fa fa-youtube-square"></i></a>
                   </div>
                </div>    
              </div>
          </div>
     </footer>
</div>

</template>

<script>
import spinner from '@/components/supportcomp/spinner.vue'    
    
export default {
  name: 'login',
  data () {
    return {
      msg: '',
      username: '',
      password: '',
      dynamicLoginIndex : 0,
      ajax_loader: false,
      selected : 0  
    }
  },
  components: {
         spinner
      },    
 methods: {
    login: function () {
             var locData = this;
             if ( this.username === "" )
                 {
                    notify('Username is empty, Please enter a valid username ...! ', 'topLeft');
                    
                     return;
                 }    
            if ( this.password === "" )
                 {

                   notify('Password is empty, Please enter a valid password ...! ', 'topLeft');
                   return;  
                 }
                
              if (this.password == "test123" && this.username=="test"){
                  $(location).attr('href','./#/home');
              }
              else{
                    
                     notify('User not authorized, Invalid Username or Password', 'topLeft');

              }

             // Login Ajax
                  /*
                $.ajax({
                  type: 'POST',
                  url:  ajaxurl+'auth_token_dcs' , //'http://192.168.1.230:3000/auth_token_dcs',
                  contentType: "application/json",    
                  async: true,
                  data: JSON.stringify({ username : this.username, password : this.password }),
                  beforeSend: function () { view_spinner(); },
                  complete: function () { close_spinner(); },     
                  success: function(data)
                  {
                	return data;
                  },
                  dataType: 'json',
                  error: function (xhr, ajaxOptions, thrownError) {
                    //alert(xhr.status);
                    //alert(thrownError);

                      if (xhr.status == '401' )
                          {
                              if ( thrownError == 'Unauthorized')
                                   {
                                              locData.dynamicLoginIndex=locData.dynamicLoginIndex+1;
                                              notify('User not authorized, Invalid Username or Password', 'warn',true,false,'topLeft');
                                              notify('Please retry, Login Count : '+locData.dynamicLoginIndex, 'warn',true,false,'topLeft');
   
                                         if (locData.dynamicLoginIndex >= 5)
                                           {
                                               notify('User account is Locked due to maximum attempt count exeeded, Please contact Support', 'warn',true,false,'topLeft');
                                           }
                                   }   
                           }
                      if (xhr.status == '0' )
                          {
                              notify('Internet connection is not available', 'warn',true,false,'topLeft');
                              
                              
                          }          
                      if (xhr.status == '500' )
                          {
                              
                              notify('Service not available, Internal Server Error', 'warn',true,false,'topLeft');
                              
                              
                          }
                  }    
                  }).done(function (data_value) {
            
                	    if (data_value.result == "AUTH_LOCKED")
                	    {
            
                           
            
                	    }    	    
                        if (data_value.result == "AUTH_FAIL")
                	    {
            
                           
            
                	    }	
                	    else
                	    {
                            
                           apikey=data_value.token;
                           $(location).attr('href','/#/home');
                               
            
                	    }
                  }); 

                  */
            
           } //login method
  }, //methods    
mounted : function () {
     //setTimeout(function(){ apikey = ""; }, 100);



  }
} //end component
</script>

<style scoped>

.wanwhite {
    z-index: 2000;
    color : #fff;  
}

@font-face {
    font-family: 'BebasNeueRegular';
    src: url('static/fonts/BebasNeue-webfont.eot');
    src: url('static/fonts/BebasNeue-webfont.eot?#iefix') format('embedded-opentype'),
         url('static/fonts/BebasNeue-webfont.woff') format('woff'),
         url('static/fonts/BebasNeue-webfont.ttf') format('truetype'),
         url('static/fonts/BebasNeue-webfont.svg#BebasNeueRegular') format('svg');
    font-weight: normal;
    font-style: normal;
}

.bring-front-2000 {
  z-index: 2000; 
}

.cb-slideshow,
.cb-slideshow:after { 
    position: fixed;
    list-style: none;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 0; 
}

.cb-slideshow li span { 
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    color: transparent;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: none;
    opacity: 0;
    z-index: -100;
	-webkit-backface-visibility: hidden;
    -webkit-animation: imageAnimation 3s linear 0s forwards;
    -moz-animation: imageAnimation 3s linear 0s forwards;
    -o-animation: imageAnimation 3s linear 0s forwards;
    -ms-animation: imageAnimation 3s linear 0s forwards;
    animation: imageAnimation 3s linear 0s forwards; 
}
.heading_comp_name { 

    color : #fff;
    font-family: 'BebasNeueRegular', 'Arial Narrow', Arial, sans-serif;
    font-size: 100px;    
    -webkit-animation: titleAnimation 36s linear 0s forwards;
    -moz-animation: titleAnimation 36s linear 0s forwards;
    -o-animation: titleAnimation 36s linear 0s forwards;
    -ms-animation: titleAnimation 36s linear 0s forwards;
    animation: titleAnimation 36s linear 0s forwards; 

}
.cb-slideshow li div h3 { 
    font-family: 'BebasNeueRegular', 'Arial Narrow', Arial, sans-serif;
    font-size: 100px;
    padding: 0;
    line-height: 200px; 
}
.cb-slideshow li:nth-child(1) span { 
    background-image: url('static/images/nice_cover_web_1.jpg') 
}

@-webkit-keyframes imageAnimation { 
    0% { opacity: 0.8;
    -webkit-animation-timing-function: ease-in; }

    17% { opacity: 0.9 }
    25% { opacity: 0.8; }
    100% { opacity: 1;}
}
@-moz-keyframes imageAnimation { 
    0% { opacity: 0.8;
    -moz-animation-timing-function: ease-in; }

    17% { opacity: 0.9 }
    25% { opacity: 0.8 }
    100% { opacity: 1 }
}
@-o-keyframes imageAnimation { 
    0% { opacity: 0.8;
    -o-animation-timing-function: ease-in; }

    17% { opacity: 0.9 }
    25% { opacity: 0.8 }
    100% { opacity: 1 }
}
@-ms-keyframes imageAnimation { 
    0% { opacity: 0.8;
    -ms-animation-timing-function: ease-in; }

    17% { opacity: 0.9 }
    25% { opacity: 0.8 }
    100% { opacity: 1 }
}
@keyframes imageAnimation { 
    0% { opacity: 0.8;
    animation-timing-function: ease-in; }

    17% { opacity: 0.9 }
    25% { opacity: 0.8 }
    100% { opacity: 1 }
}
/* Animation for the title */
@-webkit-keyframes titleAnimation { 
    0% { opacity: 0 }
    17% { opacity: 0.7 }
    19% { opacity: 0.8 }
    59% { opacity: 0.9 }
    79% { opacity: 0.6 }
    100% { opacity: 0.8 }
}
@-moz-keyframes titleAnimation { 
    0% { opacity: 0 }
    17% { opacity: 0.7 }
    19% { opacity: 0.8 }
    59% { opacity: 0.9 }
    79% { opacity: 0.6 }
    100% { opacity: 0.8 }
}
@-o-keyframes titleAnimation { 
    0% { opacity: 0 }
    17% { opacity: 0.7 }
    19% { opacity: 0.8 }
    59% { opacity: 0.9 }
    79% { opacity: 0.6 }
    100% { opacity: 0.8 }
}
@-ms-keyframes titleAnimation { 
    0% { opacity: 0 }
    17% { opacity: 0.7 }
    19% { opacity: 0.8 }
    59% { opacity: 0.9 }
    79% { opacity: 0.6 }
    100% { opacity: 0.8 }
}
@keyframes titleAnimation { 
    0% { opacity: 0 }
    17% { opacity: 0.7 }
    19% { opacity: 0.8 }
    59% { opacity: 0.9 }
    79% { opacity: 0.6 }
    100% { opacity: 0.8 }
}
/* Show at least something when animations not supported */
.no-cssanimations .cb-slideshow li span {
	opacity: 1;
}

@media screen and (max-width: 1140px) { 
    .heading_comp_name { font-size: 60px }
}
@media screen and (max-width: 600px) { 
    .heading_comp_name { font-size: 30px }
}

.smallbar{

  height: 5px;

}

.CusAdvisery {

      font-family: "Roboto", sans-serif;
    font-size: 10px;}

.CusAdvisery_help {

      font-family: "Roboto", sans-serif;
      font-size: 14px;}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/Login.vue